import type {SyntheticEvent} from 'react'
import {useState} from 'react'
import {useSafeEffect} from '@freckle/react-hooks'
import type {Props as ButtonProps} from '@freckle/educator-materials/ts/components/button'
import {Button} from '@freckle/educator-materials/ts/components/button'

export type Props = {
  onClick: (e: SyntheticEvent<EventTarget, Event>) => Promise<unknown>
} & ButtonProps

export function ButtonAsync(props: Props) {
  const {onClick: onClickFromProps, disabled: initDisabled, children, ...buttonProps} = props

  const [disabled, setDisabled] = useState<boolean>(initDisabled ?? false)

  useSafeEffect(() => {
    setDisabled(initDisabled ?? false)
  }, [initDisabled])

  function onClick(e: SyntheticEvent<EventTarget, Event>) {
    if (disabled) {
      e.preventDefault()
    } else {
      setDisabled(true)
      const promise = onClickFromProps(e)
      promise.then(() => setDisabled(false))
    }
  }

  return (
    <Button {...buttonProps} disabled={disabled} onClick={onClick}>
      {children}
    </Button>
  )
}
